import React from 'react';
import NavigationComponent from '../../commonComponents/util/NavigationComponent';
import PaginatedTable from '../../commonComponents/util/PaginatedTable';
import CampaignDetailsListsTableRow from './CampaignDetailsListsTableRow';
import VerifyListWizardModal from './VerifyCampaignListWizard/VerifyListWizardModal';
import ConfirmationModal from '../../commonComponents/shared/ConfirmationModal';
import WarningModal from '../../commonComponents/shared/WarningModal';

const initialState = {
    showModals: {
        confirmationModal: false,
        verifyWizardModal: false,
        warningModal: false
    },
    selectedRecord: {},
    recordAction: {
        actionType: '',
        action: () => { },
        actionPayload: {},
        confirmationMessage: ''
    }
};

export default class CampaignDetailsListsTable extends NavigationComponent {
    constructor(props) {
        super(props);

        this.state = initialState;

        this.getTableRow = this.getTableRow.bind(this);
    }

    selectRecord(modal, campaignList, actionType = '', action = () => { }, confirmationMessage = '', actionPayload = {}) {
        this.setState({
            selectedRecord: campaignList,
            recordAction: {
                actionType,
                action,
                actionPayload,
                confirmationMessage,
            }
        }, this.toggleModal.bind(this, modal));
    }

    getTableRow(campaignList) {
        return <CampaignDetailsListsTableRow key={campaignList.campaignListId}
            canUpdate={this.props.canUpdate}
            canApprove={this.props.canApprove}
            campaignId={this.props.campaign.campaignId}
            campaignList={campaignList}
            maxAmount={this.props.campaign.isIsraeli ? this.props.campaign.maxAmountShekel : this.props.campaign.maxAmountDollar}
            isIsraeli={this.props.campaign.isIsraeli}

            update={update => this.selectRecord("warningModal", campaignList, 'updating', this.props.update,
                'Updating the default amount will update the amount on applications associated with this list and campaign that have not yet been approved.', update)}            
            updating={this.props.updating[campaignList.campaignListId] === true}
            updateError={this.props.updating.hasOwnProperty(campaignList.campaignListId) && this.props.updating[campaignList.campaignListId] !== true}

            remove={this.selectRecord.bind(this, "confirmationModal", campaignList, 'removing', this.props.remove,
                `Are you sure you want to remove the ${campaignList.name} list from the ${this.props.campaign.name} campaign?  This will cause all applications associated with this list and campaign to be deleted.`)}

            approve={this.selectRecord.bind(this, "confirmationModal", campaignList, 'approving', this.props.approve,
                `Approve ${campaignList.name} list?`)}

            resendMessage={this.selectRecord.bind(this, "confirmationModal", campaignList, 'resendingMessage', this.props.resendMessage,
                `Resend message to ${campaignList.manager}?`)}

            verify={() => {
                this.props.getExternalUpdates(campaignList.campaignListId);
                this.selectRecord("verifyWizardModal", campaignList)
            }} />;
    }

    render() {
        let columns = [
            { id: 'status', title: 'Status', sortable: true },
            { id: 'name', title: 'Name', sortable: true },
            { id: 'count', title: 'Count', sortable: false },
            { id: 'manager', title: 'Manager', sortable: false },
            { id: 'fund', title: 'Default Fund', sortable: false },
            { id: 'defaultAmount', title: 'Default Amount', sortable: false },
            { id: 'totalCreated', title: 'Total Created', sortable: false },
            { id: 'totalPaid', title: 'Total Paid', sortable: false }
        ];
        if (this.props.canUpdate) columns.concat([
            { id: 'action', title: '', sortable: false },
            { id: 'delete', title: '', sortable: false }
        ]);

        return <div>
            <PaginatedTable
                name="campaign lists"
                page={this.props.page}
                totalCount={this.props.data.totalCount}
                resultsView={this.props.resultsView}
                sort={this.props.sort}
                loading={this.props.loading}
                success={this.props.success}
                renderRow={this.getTableRow}
                columns={columns}
                records={this.props.data.records || []}
                sortData={this.props.updateTable}
                changeDataView={this.props.updateTable}
                loadData={this.props.getCampaignLists}
                clearData={this.props.clearCampaignLists} />

            <VerifyListWizardModal
                show={this.state.showModals.verifyWizardModal}
                close={() => {
                    this.toggleModal("verifyWizardModal");
                    this.setState({ selectedRecord: initialState.selectedRecord, recordAction: initialState.recordAction });
                    this.props.clearReceivingParticipants();
                }}
                campaign={this.props.campaign}
                campaignList={this.state.selectedRecord}
                externalUpdates={this.props.externalUpdates}
                receivingParticipants={this.props.receivingParticipants}
                listRecipients={this.props.externalListRecipients}
                getListRecipients={this.props.getExternalListRecipients}
                getReceivingParticipants={(campaignListId, newParticipants, ...tableProps) => 
                    this.props.getReceivingParticipants(campaignListId, newParticipants, ...tableProps || {})}
                recipientSuggestions={this.props.recipientSuggestions}
                getRecipientSuggestions={this.props.getRecipientSuggestions}
                clearRecipientSuggestions={this.props.clearRecipientSuggestions}
                clearReceivingParticipants={this.props.clearReceivingParticipants}
                verifyUpdates={this.props.verifyExternalUpdates}
                verifyingUpdates={this.props.verifyingUpdates} />
                
            <ConfirmationModal
                show={this.state.showModals.confirmationModal}
                message={this.state.recordAction.confirmationMessage}
                close={() => {
                    this.toggleModal("confirmationModal");
                    this.setState({ selectedRecord: initialState.selectedRecord, recordAction: initialState.recordAction });
                }}
                confirm={this.state.recordAction.action.bind(this, this.props.campaign.campaignId, this.state.selectedRecord.campaignListId)}
                loading={this.props[this.state.recordAction.actionType] && this.props[this.state.recordAction.actionType].loading}
                success={this.props[this.state.recordAction.actionType] && this.props[this.state.recordAction.actionType].success}
                errorMessage={this.props[this.state.recordAction.actionType] && this.props[this.state.recordAction.actionType].message}
            />

            <WarningModal
                show={this.state.showModals.warningModal}
                message={this.state.recordAction.confirmationMessage}
                close={this.toggleModal.bind(this, "warningModal")}
                cancel={() => this.setState({ selectedRecord: initialState.selectedRecord, recordAction: initialState.recordAction })}
                continue={this.state.recordAction.action.bind(this, this.props.campaign.campaignId, this.state.selectedRecord.campaignListId, this.state.recordAction.actionPayload)} />
        </div>
    }
}


// WEBPACK FOOTER //
// ./src/components/campaignComponents/campaignDetails/CampaignDetailsListsTable.jsx